'use client';

import { CircleUserRound } from 'lucide-react';

import { Suspense } from 'react';
import { UserButton } from '@clerk/nextjs';

function AppNavUserButton() {
  return (
    <Suspense fallback={<CircleUserRound size={28} />}>
      <UserButton
        appearance={{ elements: { userButtonAvatarBox: 'w-10 h-10' } }}
      />
    </Suspense>
  );
}

export default AppNavUserButton;
